import { useState } from "react";
import { DatabaseZap, X } from "lucide-react";
import { SingleFieldData, useBatchRunner } from "./FieldActionData";
import { Modal } from "../ui/Modal";
import type { DashboardField } from "../types/contract";

// The same per-field data flow the dashboard bar used, opened from the map.
function AddFieldDataModal({
  field,
  onClose,
}: {
  field: DashboardField;
  onClose: () => void;
}) {
  const runner = useBatchRunner();
  return (
    <Modal>
      <div
        className="fixed inset-0 z-dialog flex items-center justify-center bg-black/40 p-4"
        onClick={onClose}
      >
        <div
          className="flex max-h-[85vh] w-full max-w-xl flex-col rounded-lg bg-surface text-fg shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between border-b border-line px-3 py-2">
            <h2 className="text-sm font-semibold">
              Add Field Data · {field.field_name}
            </h2>
            <button
              onClick={onClose}
              className="rounded p-1 hover:bg-hover"
              aria-label="Close"
            >
              <X size={16} />
            </button>
          </div>
          <div className="overflow-auto p-4">
            <SingleFieldData field={field} runner={runner} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export function MapAddFieldDataButton({ field }: { field: DashboardField }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="flex w-full items-center justify-center gap-1.5 rounded-md border border-line bg-canvas/40 px-3 py-2 text-xs font-medium text-fg hover:bg-hover"
      >
        <DatabaseZap size={14} /> Add Field Data
      </button>
      {open && (
        <AddFieldDataModal field={field} onClose={() => setOpen(false)} />
      )}
    </>
  );
}
